export default __webpack_public_path__ + "static/splash.3-022783b541481cef699330ae2331545b.jpeg";